import en from './en' // 英语
import cn from './cn' // 中文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
export default {
    en: Object.assign( en, enLocale ),
    cn: Object.assign( cn, zhLocale )
}